import Banner from 'components/Banner';
import { LabelButton } from 'components/buttons/LabelButton/LabelButton';
import GradientText from 'components/GradientText';
import headOfficePin from 'images/icons/headOfficePin.svg';
import './styles.scss';
import TeamSection from './TeamSection';
import MissionAndValuesSection from 'components/MissionAndValuesSection';
import OurHistory from './OurHistory';
import DefaultForm from 'components/FormSection/Forms/DefaultForm';
import { useDispatch, useSelector } from 'react-redux';
import { fetchAboutUs, selectAboutUsPage } from 'store/slices/AboutUsSlice';
import React from 'react';

const AboutUs = () => {
    const dispatch = useDispatch();

    const {
        fs_title,
        fs_background,
        fs_description,
        about_tag,
        about_title,
        about_text,
        about_card_text,
        about_card_image,
        mission_cards,
        history_title,
        histories_cards,
        histories_image,
        mission_background_image,
        mission_title,
    } = useSelector(selectAboutUsPage);

    React.useEffect(() => {
        // @ts-ignore
        dispatch(fetchAboutUs());
    }, [dispatch]);
    return (
        <>
            <Banner image={fs_background} buttonText={fs_description}>
                <GradientText size="middle" textColor="white">
                    <span dangerouslySetInnerHTML={{ __html: fs_title }} />
                </GradientText>
            </Banner>

            <section className="container">
                <div className="inner-container type-2">
                    <div className="main-text-container">
                        <LabelButton>{about_tag}</LabelButton>
                        <GradientText>
                            <span dangerouslySetInnerHTML={{ __html: about_title }} />
                        </GradientText>
                        <div className="offset-left-4 max-width-760">
                            <GradientText size="small">
                                <span dangerouslySetInnerHTML={{ __html: about_text }} />
                            </GradientText>
                        </div>
                    </div>
                </div>
            </section>

            <section className="container">
                <div className="inner-container type-2">
                    <div className="head-office">
                        <div className="head-office__left">
                            <img src={headOfficePin} alt="icon pin" />
                            <GradientText size="super-small">
                                <span dangerouslySetInnerHTML={{ __html: about_card_text }} />
                            </GradientText>
                        </div>
                        <div className="head-office__right">
                            <img src={about_card_image} alt="head office" />
                        </div>
                    </div>
                </div>
            </section>

            <MissionAndValuesSection background={mission_background_image} title={mission_title} data={mission_cards} />

            <TeamSection />

            <OurHistory title={history_title} cards={histories_cards} />

            {histories_image && (
                <section className="container about-us-photo">
                    <img src={histories_image} alt="" />
                </section>
            )}

            <DefaultForm />
        </>
    );
};
export default AboutUs;
